import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { peekPendingRecordingRedirect } from '@/entities/recording';
import { useGetSpaces } from '@/entities/teamspace/model/useGetSpaces';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

export const HomeRedirect = () => {
  const navigate = useNavigate();
  const { data: spaces, isLoading } = useGetSpaces(true);

  useEffect(() => {
    if (!isLoading && spaces?.length) {
      const spaceForRedirect = spaces[0];
      const pendingRecordId = peekPendingRecordingRedirect();
      const targetPath = pendingRecordId
        ? `/${PATHS.spaces}/${spaceForRedirect.id}/${PATHS.records}/${pendingRecordId}`
        : `/${PATHS.spaces}/${spaceForRedirect.id}`;

      navigate(targetPath, { replace: true });
    }
  }, [spaces, isLoading, navigate]);

  return <Loader />;
};
